import { z } from 'zod';

import { PayoffId } from '../BrandedIds';
import { PaymentDebitSource } from '../loan/Payments';
import { ShortageActionType, TrackedPayoffAllowedPaymentMethods } from '../loan/Payoffs';
import { zodBrandedUuid, zodDateOrString } from '../utils/Zod';
import { Float, NonNegativeFloat } from '../validations/fields';
import { BaseLoanEvent } from './BaseLoanEvent';

export const RecordPayoffEvent = BaseLoanEvent.extend({
  type: z.literal('recordPayoff'),
  shortageAction: ShortageActionType.optional(),
  dateReceived: zodDateOrString, // This is the date selected by lender while recording the payoff
  paymentMethod: TrackedPayoffAllowedPaymentMethods,
  referenceId: z.string().optional(),
  submittedBy: z.string().optional(),
  amountReceived: NonNegativeFloat,
  amountExpected: Float,
  sendEmail: z.boolean(),
  payoffId: zodBrandedUuid<PayoffId>(),
  isPartial: z.boolean().optional(),
  additionalPrincipal: NonNegativeFloat.optional(),
  additionalEscrow: NonNegativeFloat.optional(),
  additionalSuspense: NonNegativeFloat.optional(),
  now: zodDateOrString.optional(),
  debitSource: PaymentDebitSource.optional(),
});

export type RecordPayoffEvent = z.infer<typeof RecordPayoffEvent>;
